class CtrPartners extends HTMLElement {
  connectedCallback() {
    this.initMarquee();
  }

  initMarquee() {
    const marquee = this.querySelector('[ref="marquee"]');
    const track = this.querySelector('[ref="track"]');

    if (!marquee || !track || marquee.dataset.cloned === 'true') return;

    marquee.appendChild(track.cloneNode(true));
    marquee.dataset.cloned = 'true';
  }
}

customElements.get('ctr-partners') || customElements.define('ctr-partners', CtrPartners);
